import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, Table, Tabs, Tooltip, message } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EventEmitter from '../utils/eventEmitter';
import BudgetTable from '../components/BudgetTable';
import useAnalyticAccountAPI from '../apis/analyticAccountAPI';



const columns = [
  {
    title: 'Budget',
    dataIndex: 'budget_id',
    key: 'budget_id',
    className: 'text-wrap font-medium text-sky-600 dark:text-white',
    editable: true,
    // width: '10%'
  },
  {
    title: 'Budgetary Positon',
    dataIndex: 'position_id',
    key: 'position_id',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true,
    // width: '20%'
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
    key: 'start_date',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true,
    // width: '20%'
  },
  {
    title: 'End Date',
    dataIndex: 'end_date',
    key: 'end_date',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true,
    // width: '100%'
  },
  {
    title: 'Planned Amount',
    dataIndex: 'planned_amount',
    key: 'planned_amount',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    editable: true,
    // width: '20%'
  },
  {
    title: 'Practical Amount',
    dataIndex: 'practical_amount',
    key: 'practical_amount',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    // width: '10%'
  },
  {
    title: 'Theoretical Amount',
    dataIndex: 'theoretical_amount',
    key: 'theoretical_amount',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    // width: '10%'
  },
  {
    title: 'Achievement',
    dataIndex: 'achievement',
    key: 'achievement',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    // width: '10%'
  },
  {
    title: 'Action',
    dataIndex: 'action',
    key: 'action',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
];


const AnalyticAccountChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const {analytic, positions, plans, budgets } = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(analytic.name ? analytic.name : '');
  const [budgetItems, setBudgetItems] = useState(analytic.budget_items ? analytic.budget_items : []);
  const { save, update } = useAnalyticAccountAPI();


  const onChangeName = e => setName(e.target.value);

  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    budgetItems.forEach((item, idx) => {
      budgetItems[idx]['start_date'] = new Date(budgetItems[idx]['start_date']).toLocaleDateString();
      budgetItems[idx]['end_date'] = new Date(budgetItems[idx]['end_date']).toLocaleDateString();
    });
    data['budget_items'] = budgetItems;
    save(data, success);
    // console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    budgetItems.forEach((item, idx) => {
      budgetItems[idx]['start_date'] = new Date(budgetItems[idx]['start_date']).toLocaleDateString();
      budgetItems[idx]['end_date'] = new Date(budgetItems[idx]['end_date']).toLocaleDateString();
    });
    data['budget_items'] = budgetItems;
    update(analytic.seo, data, success);
    // console.log(data)
  }

  useEffect(() => {
    EventEmitter.subscribe('analytic_response', data => {
      navigate('/accounting/analytic-accounts/'+data);
    });
    return () => EventEmitter.unsubscribe('analytic_response');
  },[]);

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/accounting/analytic-accounts'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Analytic Accounts</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ analytic.name ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {analytic.name && <Button onClick={handleUpdate}>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white p-3'>
        <FloatingLabel 
          className='text-2xl' 
          variant="standard" 
          label="Analytic Account Name" 
          value={name} 
          onChange={onChangeName}
          style={{maxWidth: '500px'}}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 5}}
          initialValues={analytic.seo ? { customer: analytic.customer, reference: analytic.reference, plan_id: analytic.plan_id } :
            {}}
          variant='borderless'
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Customer' name={'customer'} className='font-semibold text-gray-800 mb-2 column' required>
                <Input className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
            </Col>
            <Col md={{span: 10}}>
              <Form.Item label='Plan' name={'plan_id'} className='font-semibold text-gray-800 mb-2 column' required>
                <Select options={plans.map(plan => ({value: plan._id, label: plan.name}))} className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal'/>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label='Reference' name={'reference'} className='font-semibold text-gray-800 mb-2 column' required>
                <Input type='text' className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal'/>
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            type="card"
            items={[
              {
                key: '1',
                label: 'Budget Items',
                children: 
                  <BudgetTable 
                    dataSource={budgetItems}
                    setEntries={setBudgetItems}
                    columns={columns}
                    positions={positions}
                    budgets={budgets}
                    period = {[]}
                    budget={true}
                  />
              },
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default AnalyticAccountChanges;